export default "__VITE_ASSET__984df369__"